import Content from './components/Content';
import Layout from './components/Layout';

import { homeLandingApi } from './api/requests.api';

export { Layout, homeLandingApi };
export default Content;
